module.exports = __webpack_public_path__ + "static/media/kubeicons.5fae77e8.svg";